'use client';

interface AnimatedSailboatProps {
  size?: number;
  color?: string;
  secondaryColor?: string;
  duration?: number;
}

export function AnimatedSailboat({ 
  size = 100, 
  color: _color,
  secondaryColor: _secondaryColor,
  duration = 3 
}: AnimatedSailboatProps) {
  const sailDuration1 = duration * 1.5;
  const sailDuration2 = duration * 1.2;
  
  return (
    <div
      className="text-slate-400 dark:text-slate-600 opacity-60 dark:opacity-30 relative inline-block transition-opacity animate-sailboat-float"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        animationDuration: `${duration}s`,
      }}
    >
      <svg
        viewBox="0 0 100 140"
        width="100%"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Hull */}
        <path
          d="M10,110 Q50,135 90,110 L80,110 L20,110 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"
        />
        
        {/* Mast */}
        <rect x="48" y="10" width="4" height="100" fill="currentColor" />
        
        {/* Main Sail */}
        <g
          className="animate-sail-sway"
          style={{
            animationDuration: `${sailDuration1}s`,
            transformOrigin: '50px 110px',
          }}
        >
          <path
            d="M52,15 L52,105 L90,105 Q70,50 52,15 Z"
            fill="currentColor"
            opacity="0.9"
          />
        </g>
        
        {/* Jib Sail */}
        <g
          className="animate-sail-sway"
          style={{
            animationDuration: `${sailDuration2}s`,
            animationDirection: 'reverse',
            transformOrigin: '48px 110px',
          }}
        >
          <path
            d="M48,15 L48,105 L15,105 Q30,50 48,15 Z"
            fill="currentColor"
            opacity="0.8"
          />
        </g>
        
        {/* Flag */}
        <path
          d="M48,10 L30,15 L48,20 Z"
          fill="#FFB347"
          className="animate-sail-sway"
          style={{ animationDuration: '1s' }}
        />
      </svg>
    </div>
  );
}

